import { ToastContainer } from "react-toastify";
import { BtnSubmit } from "../../../components/button/button-submit/button-submit";
import MaskInput from "../../../components/inputs/mask";
import TextInput from "../../../components/inputs/text";
import libForm from "../../../util/libForm";
import { IndexHook } from "./hooks";
import { Link } from "react-router-dom";
import PasswordInput from "../../../components/inputs/password";
import Loading from "../../../components/loading";

const FormRegisterNewStore = (props) => {
	const { productSelected, handleOnSubmit, register, handleSubmit, control, reset, errors, isSubmitting, loading } =
		IndexHook();

	return (
		<>
			{loading ? (
				<div className="flex items-center justify-center h-48">
					<Loading mensagem="Salvando dados..." />
				</div>
			) : (
				<div className="container-forms m-3 bg-white shadow-md rounded-lg">
					{/* Título e Subtítulo */}
					<div className="p-4">
						<ToastContainer />
						<header className="">
							<h1 className="text-2xl font-bold text-gray-800">
								Crie sua Conta gratuitamente para testar.
							</h1>
							<p className="text-sm text-gray-500 mb-3">
								Preencha as informações abaixo para experimentar nosso sistema gratuitamente.
							</p>
							{productSelected && (
								<h2 className="text-sm text-gray-500 mb-2">{` Produto selecionado: ${productSelected}`}</h2>
							)}
						</header>

						{/* Formulário */}
						<form className="form mt-4" onSubmit={handleSubmit(handleOnSubmit)}>
							<main>
								<div className="grid grid-cols-12 gap-3">
									{/* Contato */}
									<TextInput
										label="Nome do Contato"
										id="contato"
										placeholder="Ex: João Silva"
										register={register}
										errors={errors}
										onKeyDown={libForm.EnterTab}
										autoFocus={true}
										className="col-span-12 sm:col-span-6 lg:col-span-4"
									/>

									{/* Empresa */}
									<TextInput
										label="Nome da Empresa"
										id="nome"
										placeholder="Ex: Empresa X"
										register={register}
										errors={errors}
										onKeyDown={libForm.EnterTab}
										className="col-span-12 sm:col-span-6 lg:col-span-4"
									/>

									{/* Telefone */}
									<MaskInput
										label="Telefone"
										name="telefone_1"
										control={control}
										errors={errors}
										required={false}
										onKeyDown={libForm.EnterTab}
										format="(##)#####-####"
										className="col-span-12 sm:col-span-6 lg:col-span-4"
									/>

									{/* Email */}
									<TextInput
										label="Email"
										id="email"
										placeholder="Ex: email@empresa.com"
										register={register}
										errors={errors}
										onKeyDown={libForm.EnterTab}
										className="col-span-12 sm:col-span-6 lg:col-span-4"
										// type="email"
									/>

									{/* Senha */}
									<PasswordInput
										label="Senha"
										id="senha"
										placeholder="Crie uma senha segura"
										register={register}
										errors={errors}
										onKeyDown={libForm.EnterTab}
										className="col-span-12 sm:col-span-6 lg:col-span-4"
										toUpperCase={false}
									/>
								</div>
							</main>

							{/* Botões */}
							<div className="mt-6 flex justify-between">
								{/* <BtnBack
						text="Voltar"
						onClick={() => props.onBack()}
						className="btn btn-secondary"
					/> */}
								<BtnSubmit text="Criar Conta" className="btn btn-primary" isSubmitting={isSubmitting} />
							</div>
						</form>

						<div className="mt-4">
							<Link to="/login" className="text-blue-500 underline">
								Já tenho uma conta
							</Link>
						</div>
					</div>
				</div>
			)}
		</>
	);
};

export default FormRegisterNewStore;
